import React, { Component } from "react";
import "./index.css";

const Hero = () => (
  <div className="hero-area-content text-center">
    <h1
      style={{
        color: "var(--h1Color)"
      }}
    >
      Hi
    </h1>
    <p
      style={{
        color: "var(--pColor)"
      }}
    >
      Tau.support is here to assist you through the tau universe <br></br> with
      the latest <span style={{ color: "var(--heroText)" }}>news, market</span>{" "}
      data & <span style={{ color: "var(--heroText)" }}>apps</span>
    </p>
    <button
      className="btn btn-primary cta-btn mt-3"
      type="button"
      style={{ background: "var(--btnColor)" }}
    >
      Join the network
      <img
        className="img-fluid ml-2"
        src={require("../../../assets/icons/arrow-icon.svg")}
        alt="Arrow"
      />
    </button>
  </div>
);

export default Hero;
